module.exports = __webpack_public_path__ + "img/weixin.23cf94b9.png";